<div cdkTrapFocus class="activity-indicator-container">
  <div
    [ngStyle]="{ visibility: showLoader ? 'hidden' : 'visible' }"
    class="content-container"
  >
    <ng-content></ng-content>
  </div>
  <div *ngIf="showLoader" class="indicator-overlay"></div>
</div>
